export default __webpack_public_path__ + "static/media/img-0270-saudi-arabia-premium-face.04c22913.png";